import { animate, useReducedMotion } from "motion/react";
import { useEffect, useRef, useState } from "react";
import { REVEAL_EASE } from "@/src/common/components/animated-section";
import { useEntrance } from "@/src/common/hooks/use-entrance";

interface CountUpProps {
	to: number;
	suffix?: string;
	prefix?: string;
	duration?: number;
	className?: string;
}

export function CountUp({ to, suffix = "", prefix = "", duration = 1.4, className = "" }: CountUpProps) {
	const ref = useRef<HTMLSpanElement>(null);
	const reduced = useReducedMotion() === true;
	const entrance = useEntrance(ref, { amount: 0.6, margin: "0px", disabled: reduced });
	const [value, setValue] = useState(to);
	const resetOffscreen = useRef(false);

	useEffect(() => {
		if (entrance === "hidden") {
			resetOffscreen.current = true;
			setValue(0);
			return;
		}
		if (entrance !== "visible" || !resetOffscreen.current) return;
		const controls = animate(0, to, {
			duration,
			ease: REVEAL_EASE,
			onUpdate: (latest) => setValue(Math.round(latest)),
		});
		return () => controls.stop();
	}, [entrance, to, duration]);

	return (
		<span ref={ref} className={`tabular-nums ${className}`}>
			{prefix}
			{value}
			{suffix}
		</span>
	);
}
